import { actionTypes } from 'redux-form'
// import { LOCATION_CHANGE } from 'react-router-redux'
import {
  CREATE,
  CREATE_SUCCESS,
  CREATE_FAILURE,
  UPDATE,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
} from '@/state/types/data'

export default (previousState = false, { type, payload }) => {
  switch (type) {
    case CREATE:
    case UPDATE:
      return { redirect: payload.redirectTo }
    // case LOCATION_CHANGE:
    case actionTypes.SET_SUBMIT_FAILED:
    case CREATE_SUCCESS:
    case CREATE_FAILURE:
    case UPDATE_SUCCESS:
    case UPDATE_FAILURE:
      return false
    default:
      return previousState
  }
}



// WEBPACK FOOTER //
// ./state/reducers/saving.js